export const handleImgError = e => {
  e.target.src = '/no-image.jpg';
};
